<script>
    import {fade, fly} from 'svelte/transition';
    import R, {LOADER} from "../lib/requests";
    import passportsStore from "../stores/passportsStore";
    import AppIcon from "../components/icons/AppIcon.svelte";
    import {copyObject, passportStatus} from "../lib/lib";
    import {PASSPORT_STATUS} from "../lib/constants";
    import Alert from "../stores/alerts";

    let loading = false;
    let error = null;
    let errorStatus = null;
    let complete = null;
    let syncData = null;
    let showPopup = true;

    const login = () => {
        const onSuccess = result => {
            loading = null;
            if (!result) {
                error = "Δεν υπήρξε απάντηση από τον διακομιστή κατά τη σύνδεση στον λογαριασμό του pet.gov.gr";
                return;
            }
            $passportsStore.token = result;
        }

        const onFailure = err => {
            loading = null;
            error = '';
            if (err.params) {
                errorStatus = err.params.status;
                if (err.params.code) {
                    error = `Κωδικός: ${err.params.code}`;
                }
                error += (error ? "<br>" : "") + err.params.description;
            } else {
                if (err.description) {
                    error = err.description;
                } else {
                    error = err.message;
                }
            }
        };

        error = null;
        errorStatus = '';
        loading = 'Σύνδεση με διακομιστή διαβατηρίων';
        R.handle(R.passport.apiLogin, {}, onSuccess, onFailure, LOADER.NONE);
    }

    const request = () => {
        const onSuccess = result => {
            loading = null;
            if ($passportsStore.sync_data.status === PASSPORT_STATUS.CHECK) {
                $passportsStore.sync_callback(result);
                close();
            } else {
                if (result.status == PASSPORT_STATUS.ASSIGNED) {
                    complete = "Η ανάθεση ολοκληρώθηκε";
                } else if (result.status == PASSPORT_STATUS.RETURNED) {
                    complete = "Η επιστροφή ολοκληρώθηκε";
                } else if (result.status == PASSPORT_STATUS.DESTROYED) {
                    complete = "Η καταστροφή ολοκληρώθηκε";
                } else {
                    complete = "Ολοκληρώθηκε";
                }
            }
            if ($passportsStore.sync_callback) {
                $passportsStore.sync_callback(result);
            }
        }

        const onFailure = err => {
            loading = null;
            error = '';
            if (err.params) {
                errorStatus = err.params.status;
                if (err.params.code) {
                    error = `Κωδικός: ${err.params.code}`;
                }
                error += (error ? "<br>" : "") + err.params.description;
            } else {
                error = err.message;
            }
            // Alert.warning("Σφάλμα διαβατηρίων", error);
            if ($passportsStore.sync_callback) {
                $passportsStore.sync_callback({error: err.params.description});
            }
        };

        error = null;
        errorStatus = '';
        syncData = copyObject($passportsStore.sync_data);

        loading = passportStatus(syncData.status) + ' διαβατηρίων';
        let data = {
            token: $passportsStore.token,
            action: syncData.status,
            data: syncData
        };
        // return;
        R.handle(R.passport.apiRequest, data, onSuccess, onFailure, LOADER.NONE);
    }

    const onClose = () => {
        if (loading) {
            return;
        }

        if ($passportsStore.close_callback) {
            $passportsStore.close_callback();
        }

        showPopup = false;

        setTimeout(() => {
            passportsStore.clearRequest();
        }, 200);
    }

    const close = () => {
        if (loading) {
            return;
        }

        showPopup = false;
        passportsStore.clearRequest();
    }


    $: if ($passportsStore.sync_data) {
        if (!$passportsStore.token && !error) {
            login();
        }
    }
</script>
{#if showPopup}
    <div class="passport-loader-overlay" transition:fade="{{ duration: 100 }}">
        <div class="passport-loader-box">
            <div class="close" on:click={ onClose }>&times;</div>
            <div class="icon">
                <AppIcon icon="passport" size="100"/>
            </div>
            <div class="content">
                {#if loading}
                    <div class="loading">
                        {@html loading }
                    </div>
                    <div class="spinner-icon">
                        <div class="spinner-border text-primary" role="status"></div>
                    </div>
                {:else if error}
                    <h6 class="text-danger mb-2">Σφάλμα { errorStatus }</h6>
                    <div class="mb-2">
                        {@html error }
                    </div>
                    <button class="btn btn-link py-0" on:click={ onClose }>Κλείσιμο</button>
                {:else if complete}
                    <h6 class="mb-2">Η αποστολή ολοκληρώθηκε</h6>
                    <button class="btn btn-link py-1" on:click={ onClose }>Κλείσιμο</button>
                {:else}
                    <h6 class="mb-1">
                        {#if $passportsStore.sync_data.status == PASSPORT_STATUS.ASSIGN}
                            Ανάθεση διαβατηρίων
                        {:else if $passportsStore.sync_data.status == PASSPORT_STATUS.RETURN}
                            Επιστροφή διαβατηρίων
                        {:else if $passportsStore.sync_data.status == PASSPORT_STATUS.DESTROY}
                            Καταστροφή διαβατηρίων
                        {/if}
                    </h6>
                    <div class="mb-2">
                        { $passportsStore.prefix }{ $passportsStore.sync_data.passport_from }
                        - { $passportsStore.prefix }{ $passportsStore.sync_data.passport_to }
                    </div>
                    <button class="btn py-1"
                            class:btn-primary={ $passportsStore.sync_data.status == PASSPORT_STATUS.ASSIGN }
                            class:btn-success={ $passportsStore.sync_data.status == PASSPORT_STATUS.RETURN }
                            class:btn-danger={ $passportsStore.sync_data.status == PASSPORT_STATUS.DESTROY }
                            on:click={ request }>
                        ΑΠΟΣΤΟΛΗ
                    </button>
                {/if}
            </div>
        </div>
    </div>
{/if}

<style>
    .passport-loader-overlay {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 9910;
        background: rgba(0, 0, 0, 0.5);
    }

    .passport-loader-box {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 450px;
        max-width: 100%;
        display: flex;
        align-items: center;
        background: #fff;
        border-radius: 5px;
        box-shadow: 0 0 5px -2px rgba(0, 0, 0, 0.70);
        -webkit-box-shadow: 0 0 5px -2px rgba(0, 0, 0, 0.70);
        -moz-box-shadow: 0 0 5px -2px rgba(0, 0, 0, 0.70);
        padding: 25px;

    }

    .passport-loader-box .close {
        position: absolute;
        top: 0;
        right: 6px;
        font-size: 30px;
        cursor: pointer;
        padding: 5px;
        line-height: 1;
    }

    .passport-loader-box .icon {
        color: #737373;
    }

    .passport-loader-box .content {
        position: relative;
        width: calc(100% - 60px);
        text-align: center;
        padding-left: 15px;
    }

    .passport-loader-box .content .loading {
        margin-bottom: 4px;
    }

    .spinner-icon {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        opacity: 0.3;
    }

    .spinner-border {
        display: block;
        margin: auto;
    }
</style>
